import { render, staticRenderFns } from "./snack-bar.vue?vue&type=template&id=4520ffe8&lang=jade&"
import script from "./snack-bar.vue?vue&type=script&lang=js&"
export * from "./snack-bar.vue?vue&type=script&lang=js&"
import style0 from "./snack-bar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports